<template>
  <div class="space-y-1">
    <template v-for="{ modes, ...card } in statistics">
      <StatisticsCard
        v-if="card.image && (!modes.length || modes.includes(mode))"
        :key="card.text"
        v-bind="card"
      />
    </template>
    <template v-for="{ modes, ...card } in funFacts">
      <FunFactsCard
        v-if="card.image && (!modes.length || modes.includes(mode))"
        :key="card.text"
        v-bind="card"
      />
    </template>
  </div>
</template>

<script>
import FunFactsCard from '@/components/FunFactsCard.vue'
import StatisticsCard from '@/components/StatisticsCard.vue'
import { mapGetters } from 'vuex'
import { WATCH_UPDATE_INTERVAL } from '@/constants/intervals'

export default {
  name: 'StatisticCards',
  components: {
    FunFactsCard,
    StatisticsCard
  },
  props: {
    type: {
      type: String,
      default: 'statistics',
      validator: value => ['statistics', 'funFacts'].includes(value)
    }
  },
  data() {
    return {
      /**
       * @type {
       * Array<{
       *   color: string
       *   image: toString
       *   decimals?: number
       *   flip?:boolean
       *   modes: string[]
       *   text: toString
       *   value: number | number[]
       * }>
       * }
       */
      statistics: [],
      /**
       * @type {
       * Array<{
       *   color: string
       *   header?:string
       *   image: toString
       *   modes: string[]
       *   text: toString
       *   value: number | number[]
       * }>
       * }
       */
      funFacts: []
    }
  },
  computed: {
    ...mapGetters([
      'mode'
    ])
  },
  mounted() {
    this.fetch()
    const i = setInterval(() => this.fetch(), WATCH_UPDATE_INTERVAL)

    this.$on('hook:beforeDestroy', () => {
      clearInterval(i)
    })
  },
  methods: {
    async fetch() {
      const response = await fetch(
        `${process.env.BASE_URL}${process.env.VUE_APP_JSON_URL}${this.type}.json`
      )
      if (response.ok && response.headers.get('content-type')
        .match(/application\/json/)) {
        this[this.type] = await response.json()
      }
    }
  }
}
</script>

<style lang="scss">
.space-y-1 {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}
</style>
